var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Container, Grid } from 'semantic-ui-react';
import { checkIfProfileComplete } from 'app/helpers/userHelper';
import TermsAndConditions from "containers/Onboarding/TermsAndConditions";
import Header from './Header';
import { styles } from './style';
import AccountSetup from './AccountSetup/AccountSetup';
var trakingPlatforms = {
    none: true,
    mixpanel: true,
};
var OnboardingIndex = /** @class */ (function (_super) {
    __extends(OnboardingIndex, _super);
    function OnboardingIndex(props) {
        var _this = _super.call(this, props) || this;
        if (!props.user || !props.user.accessToken)
            return _this;
        _this.handleContinue = _this.handleContinue.bind(_this);
        _this.steps = [];
        var _a = _this.props, user = _a.user, history = _a.history;
        var first_name = user.first_name, last_name = user.last_name, company = user.company;
        var hasCompletedProfile = checkIfProfileComplete(user);
        if (!hasCompletedProfile) {
            _this.steps.push({
                title: 'Terms and Conditions',
                slug: 'terms',
                Component: TermsAndConditions,
            });
            _this.steps.push({
                title: 'Setup Account',
                slug: 'setup-account',
                Component: AccountSetup,
            });
        }
        _this.state = {};
        if (_this.steps.length === 0) {
            history.push({
                pathname: '/',
                search: history.location.search,
            });
        }
        else {
            window.neo4jSandbox.tracking.event('SANDBOX_ONBOARDING_SHOW', {
                stepsCount: _this.steps.length,
                hasProfileStep: hasCompletedProfile,
                missingFields: (!first_name ? 'firstName-' : '') +
                    (!last_name ? 'lastname-' : '') +
                    (!company ? 'company' : ''),
            }, trakingPlatforms);
            _this.state = {
                currentStepIndex: 0,
            };
        }
        return _this;
    }
    OnboardingIndex.prototype.handleContinue = function (data) {
        var _this = this;
        // If data is sent, then update mixpanel user profile with it
        if (data) {
            data.forEach(function (item) {
                window.neo4jSandbox.tracking.setUserProperty(item.key, item.value);
                // 	// if the key is "Sandbox: Purpose", then store it in state. This is required to the sent
                // 	// to the next step to decide what questions to ask
                // 	if (item.key === 'Sandbox Purpose') {
                // 		this.setState({
                // 			sandboxPurpose: item.value,
                // 		});
                // 	}
            });
        }
        var history = this.props.history;
        var currentStepIndex = this.state.currentStepIndex;
        this.setState({
            currentStepIndex: currentStepIndex + 1,
        }, function () {
            window.neo4jSandbox.tracking.event('SANDBOX_ONBOARDING_STEP_COMPLETE', {
                index: currentStepIndex,
                stepName: _this.steps[currentStepIndex].slug,
            }, trakingPlatforms);
            var nextStepIndex = _this.state.currentStepIndex;
            if (nextStepIndex === _this.steps.length) {
                window.neo4jSandbox.tracking.event('SANDBOX_ONBOARDING_COMPLETE', {}, trakingPlatforms);
                history.push({
                    pathname: '/',
                    search: history.location.search,
                });
            }
        });
    };
    OnboardingIndex.prototype.render = function () {
        var _this = this;
        if (!this.props.user)
            return null;
        var _a = this.state, currentStepIndex = _a.currentStepIndex, sandboxPurpose = _a.sandboxPurpose;
        var user = this.props.user;
        return (React.createElement(Container, { className: "mt4" },
            React.createElement(Grid, { centered: true },
                React.createElement(Grid.Column, { width: 8 },
                    React.createElement("h2", { className: "text-center", style: { marginBottom: 32 } },
                        "Let's setup your account in ",
                        React.createElement("b", null, "~ 30 seconds")),
                    React.createElement(Header, { currentStep: currentStepIndex, steps: this.steps }),
                    React.createElement("div", { className: "mt3 pt4 pb4", style: styles.body }, this.steps.map(function (step, i) {
                        return i === currentStepIndex ? (React.createElement(step.Component, { key: i, onContinue: _this.handleContinue, currentStepIndex: currentStepIndex, totalSteps: _this.steps.length, userProfile: user, sandboxPurpose: sandboxPurpose })) : null;
                    }))))));
    };
    return OnboardingIndex;
}(Component));
var mapStateToProps = function (state) { return ({
    user: state.user,
}); };
export default connect(mapStateToProps)(OnboardingIndex);
